<template>
  <el-dialog
    title="批量导出导购码"
    :visible.sync="codeVisible"
    width="1025px"
    :before-close="dialogClose"
  >
    <div>
      <el-tabs
        v-model="activeName"
        @tab-click="handleTabClick"
      >
        <el-tab-pane
          label="按门店导出"
          name="store"
        >
          <div>
            <!-- 查询区 -->
            <ul class="search-btn">
              <li>
                <span class="m-r-6">门店编号</span>
                <el-input
                  v-model="params.store_bn"
                  placeholder="请输入内容"
                  class="input-m m-r-6"
                  clearable
                />
              </li>
              <li>
                <span class="m-r-6">门店名称</span>
                <el-input
                  v-model="params.store_name"
                  placeholder="请输入内容"
                  class="input-m m-r-6"
                  clearable
                />
              </li>
              <li>
                <el-button
                  type="primary"
                  @click="searchList"
                >
                  查询
                </el-button>
                <el-button
                  type="primary"
                  @click="submitExport"
                >
                  批量导出导购码
                </el-button>
              </li>
            </ul>

            <div style="margin-bottom: 15px" />
            <el-table
              ref="multipleTable"
              v-loading="loading"
              :data="storeData"
              tooltip-effect="dark"
              :row-key="getRowKeys"
              @selection-change="handleSelectionChange"
            >
              <el-table-column
                type="selection"
                :reserve-selection="true"
                width="50"
              />
              <el-table-column
                prop="store_bn"
                width="200px"
                label="门店编号"
              />
              <el-table-column
                prop="store_name"
                label="门店"
              />
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="downloadCode(scope.row)"
                  >
                    导出导购码
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <div
              slot="footer"
              class="dialog-footer select-footer"
            >
              <div>
                <el-pagination
                  layout="total, prev, pager, next, jumper"
                  :total="total_count"
                  :page-size="params.page_size"
                  @current-change="handleCurrentChange"
                />
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="按门店序号导出"
          name="code"
        >
          <el-button
            v-for="(item, index) in section"
            :key="index"
            type="primary"
            class="m-r-6"
            @click="downLoadSection(item)"
          >
            确定导出({{ item.text }})
          </el-button>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>
</template>

<script>
import { getCodeList, exportCode } from '@/api/staffManagement/salesman'
export default {
  props: ['codeVisible'],
  data () {
    return {
      activeName: 'store',
      params: {
        page: 1,
        page_size: 10,
        region: '',
        store_name: '',
        store_bn: ''
      },
      storeData: [],
      total_count: 0,
      loading: false,
      multipleSelection: [],
      section: []
    }
  },
  watch: {
    codeVisible (newvalue) {
      if (newvalue) {
        this.getList()
      }
    }
  },
  methods: {
    // 换页可选择
    getRowKeys (row) {
      return row.store_id
    },
    handleTabClick () {
      console.log(this.activeName, 'activeName')
    },
    dialogClose () {
      this.$emit('closeDialog')
    },
    // 获取门店列表
    async getList () {
      this.loading = true
      const data = await getCodeList(this.params).catch(() => {
        this.loading = false
      })
      if (data) {
        this.loading = false
        this.storeData = data.stores_list.list
        this.total_count = data.stores_list.total_count

        this.section = data.section
      }
    },
    // 分页器页面切换
    handleCurrentChange (page_num) {
      this.params.page = page_num
      this.getList()
    },
    // 查询门店
    searchList () {
      this.params.page = 1
      this.getList()
    },
    // 列表选择
    handleSelectionChange (val) {
      this.multipleSelection = val
    },

    // 单个下载
    downloadCode (row) {
      let params = {
        store_id: row.store_id.toString()
      }
      this.downLoadZip(params)
    },

    // 批量导出门店码
    submitExport () {
      let storeIds = []
      this.multipleSelection.forEach((v) => {
        storeIds = storeIds.concat(v.store_id)
      })
      let params = {
        store_id: storeIds.join(',')
      }
      this.downLoadZip(params)
    },

    // 按门店序号导出
    async downLoadSection (item) {
      let params = {
        section: item.start + ',' + item.end
      }
      this.downLoadZip(params)
    },

    // 批量导出
    async downLoadZip (params) {
      const data = await exportCode(params)
      if (data) {
        this.$message({
          message: '导出成功，请稍后到 导出列表 进行下载！',
          type: 'success'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-btn {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  li {
    margin-right: 20px;
  }
}
.select-footer {
  padding-top: 20px;
  display: flex;
  justify-content: center;
}
</style>
